import { Alert, Box } from '@mui/material';

import { useCampaignPageContext } from '../../../../../hooks/Contexts/Pages/CampaignPageContext';
import PerformanceTab from '../../../../campaignManager/campaignDetailView/PerformanceTab';

const CampaignPagePerformancePageTab = () => {
    const { campaign } = useCampaignPageContext();

    return (
        <Box
            sx={{
                '& .MuiCard-root': { border: 0 },
                '& .MuiCardContent-root': { padding: '28px', paddingTop: '12px' },
            }}
        >
            <PerformanceTab
                campaign={campaign}
                headerSlot={
                    <Alert severity="warning" sx={{ py: 0 }}>
                        This tab is only visible to Admin users and Loon Agency users.
                    </Alert>
                }
            />
        </Box>
    );
};

export default CampaignPagePerformancePageTab;
